import { ListTerrotoriesSortFields, ListTerrotoriesSortOrder } from 'generated/graphql'

export const DEFAULT_SORT = {
  field: ListTerrotoriesSortFields.AvgEngagement,
  order: ListTerrotoriesSortOrder.Desc,
}

export const PAGINATION_LIMIT = 25
export const DEFAULT_TIME = 12
